import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { loginSchema } from "../../../helpers/yup_validator";
import { post } from "../../../helpers/api_helper";
import { loginFailure, loginSuccess } from "../../../store/auth";
import email_icon from "../../../Assets/svg/email_icon.svg";
import show_eye_icon from "../../../Assets/svg/show_eye_icon.svg";
import hide_eye_icon from "../../../Assets/svg/hide_eye_icon.svg";
import password_icon from "../../../Assets/svg/password_icon.svg";
import toast from "react-hot-toast";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      showPassword: false,
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting, setErrors, setStatus }) => {
      try {
        const loginData = {
          email: values.email,
          password: values.password,
        };

        const response = await post("/user/login", loginData);

        if (response.success) {
          dispatch(
            loginSuccess({
              token: response?.data?.token,
              userData: response?.data?.userDetail,
            })
          );
          toast.success(response.message || "Login Successfully");
          navigate("/home");
        } else {
          setStatus({
            server: response.message || "Login failed. Please try again.",
          });
          dispatch(
            loginFailure(response.message || "Login failed. Please try again.")
          );
        }
      } catch (error) {
        console.error(error);
        if (error.response) {
          const { status, data } = error.response;
          if (status === 400 || status === 401) {
            setErrors({
              email: data.email || "",
              password:
                data.password || "Invalid email or password. Please try again.",
            });
          } else {
            setStatus({
              server: data.message || "Server error. Please try again later.",
            });
          }
        } else {
          setStatus({
            server:
              error.message || "Network error. Please check your connection.",
          });
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (token) {
      navigate("/home");
    }
  }, [token, navigate]);

  return (
    <div className="formInner">
      <div className="top py-2 text-center">
        <h2 className="m-0 fw-sbold head">Welcome Back !</h2>
        <p className="m-0 py-1">Please enter your details</p>
      </div>
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col lg="12" className="my-3">
            <div className="FormHeading">
              <h4 className="m-0 fw-sbold">Login</h4>
              <p className="m-0">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis{" "}
              </p>
            </div>
          </Col>
          <Col lg="12" className="my-3">
            <div className="position-relative labelInput">
              <div className="iconWithText position-relative">
                <input
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="form-control "
                  placeholder="abc@gmail.com"
                />
                <span className="icn position-absolute" style={{ left: "8px" }}>
                  <img src={email_icon} alt="" />
                </span>
              </div>
              <label
                htmlFor=""
                className="form-label position-absolute d-inline-block bg-white m-0 px-1"
              >
                Email
              </label>
              {formik.touched.email && formik.errors.email ? (
                <div className="text-danger">{formik.errors.email}</div>
              ) : null}
            </div>
          </Col>
          <Col lg="12" className="my-3">
            <div className="position-relative labelInput">
              <div className="iconWithText position-relative">
                <input
                  type={formik.values.showPassword ? "text" : "password"}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="form-control "
                  placeholder="********"
                />
                <span className="icn position-absolute" style={{ left: "8px" }}>
                  <img src={password_icon} alt="" />
                </span>
                <Button
                  onClick={() =>
                    formik.setFieldValue(
                      "showPassword",
                      !formik.values.showPassword
                    )
                  }
                  variant="transparent"
                  className="border-0 p-0 icn position-absolute"
                  style={{ right: "8px" }}
                >
                  {formik.values.showPassword ? (
                    <img src={show_eye_icon} alt="" />
                  ) : (
                    <img src={hide_eye_icon} alt="" />
                  )}
                </Button>
              </div>
              <label
                htmlFor=""
                className="form-label position-absolute d-inline-block bg-white m-0 px-1"
              >
                Password
              </label>
              {formik.touched.password && formik.errors.password ? (
                <div className="text-danger">{formik.errors.password}</div>
              ) : null}
            </div>
          </Col>
          <Col lg="12" className="my-3">
            <div className="d-flex justify-content-between align-items-center">
              <label htmlFor="remember" className="d-flex align-items-center">
                <input type="checkbox" id="remember" className="me-2" />
                Remember me
              </label>
              <Link to="/forgot-password" className="text-decoration-none">
                Forgot Password?
              </Link>
            </div>
          </Col>
          {formik.status && formik.status.server ? (
            <div className="text-danger">{formik.status.server}</div>
          ) : null}
          <Col lg="12" className="my-3">
            <Button
              type="submit"
              className="d-flex align-items-center justify-content-center w-100 commonBtn"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? "Logging in..." : "LOGIN"}
            </Button>
            <div className="text-center mt-3">
              <p className="m-0 fw-sbold">
                Don't have an account?{" "}
                <Link className="themeClr" to={"/signup"}>
                  Sign Up
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Login;
